import script from "./OtherDirectTaxable.vue?vue&type=script&setup=true&lang=js"
export * from "./OtherDirectTaxable.vue?vue&type=script&setup=true&lang=js"

import "./OtherDirectTaxable.vue?vue&type=style&index=0&id=71900ec0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71900ec0"]])

export default __exports__